export { runTask } from './run-task.js';
export { scheduleTask } from './schedule-task.js';
export { throttleTask } from './throttle-task.js';
export { _setRegisteredTimers, cancelTask } from './cancel-task.js';
export { _setRegisteredPollers, cancelPoll, pollTask, setShouldPoll } from './poll-task.js';
export { cancelDebounce, debounceTask } from './debounce-task.js';
export { getTimeoutOrTestFallback } from './utils/get-timeout-or-test-fallback.js';
import '@ember/runloop';
import '@ember/destroyable';
import './utils/get-task.js';
import '@ember/debug';
import 'ember';
